import dayjs from "dayjs"
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'

type AuthContext = {
  to: RouteLocationNormalized
  next: NavigationGuardNext
}

const auth = ({
  to,
  next,
}: AuthContext): void => {
  const company = to?.params?.company as string | undefined
  const tokenExp = localStorage.getItem('tokenExp')
  if (tokenExp && dayjs(tokenExp).isBefore(dayjs())) {
    localStorage.removeItem('token')
    localStorage.removeItem('tokenExp')
    sessionStorage.setItem('userRequestUrl', JSON.stringify({ name: to.name, query: to.query, params: to.params }))
    const loginPath = company ? { name: 'company-login', params: { company } } : { name: 'login' }
    return next(loginPath)
  }
  const isAuth = localStorage.getItem('token')

  if (!isAuth) {
    sessionStorage.setItem('userRequestUrl', JSON.stringify({ name: to.name, query: to.query, params: to.params }))
    const loginPath = company ? { name: 'company-login', params: { company } } : { name: 'login' }
    return next(loginPath)
  }

  return next()
}

export default auth
